const constants = {
  title: "Página no encontrada",
};

export default constants;
